import { Step4FormContactPersonsProps, Step4FormProps } from '../types'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { useFieldArray } from 'react-hook-form'
import { useCallback } from 'react'
import React from 'react'

const useStep4FormContactPersons = (
    form: Step4FormProps['form'],
    activationObject?: ActivationObject
): Step4FormContactPersonsProps => {
    const personsFieldArray = useFieldArray({
        control: form.control,
        name: 'personContacts',
    })

    const handleAddPerson = useCallback(
        (newIndex: number) => {
            if (personsFieldArray.fields.length < 4)
                personsFieldArray.append({
                    email: '',
                    fullName: '',
                    phone: '',
                    role: 'Admin',
                    creatAccountToZZ: false,
                    order: newIndex,
                })
        },
        [personsFieldArray]
    )

    const handlePersonEmailChange = useCallback(() => {
        personsFieldArray.swap(0, 0)
    }, [personsFieldArray])

    React.useEffect(() => {
        if (personsFieldArray.fields.length === 0) handleAddPerson(0)
    }, [handleAddPerson, personsFieldArray.fields.length])

    return {
        fields: personsFieldArray.fields,
        add: handleAddPerson,
        update: handlePersonEmailChange,
        remove: personsFieldArray.remove,
    }
}

export default useStep4FormContactPersons
